<template>
  <b-container fluid class="bg-white">
    <b-row><b-col>&nbsp;</b-col></b-row>
    <b-row class="mb-3">
      <b-col>
        <h3 tabindex="0">Gerenciar Configuração da Conferência</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-col class="table-responsive">
          <b-table selectable select-mode="multi" id="configurarConferencias" :fields="campos"
            :items="configurarConferencias" :per-page="totalPorPagina" :current-page="paginaAtual" small bordered outlined>
            <template #cell(nome)="data">{{ data.item.nome }} - {{ data.item.sigla }}</template>
            <template #cell(publica)="data">{{ data.item.publica ? 'Sim' : 'Não' }}</template>
            <template #cell(execucao_inicio)="data">{{ formatarData(data.item.execucao_inicio) }}</template>
            <template #cell(execucao_termino)="data">{{ formatarData(data.item.execucao_termino) }}</template>
            <template #cell(id)="data">
              <b-button title="Editar" class="btn btn-sm btn-secondary action" @click="editar()">
                <i class="fa fa-edit" style="color: black" />
              </b-button>
              <b-button title="Relacionar Conferências" class="btn btn-sm btn-secondary action" @click="relacionar()">
                <i class="fa fa-refresh" style="color: black" />
              </b-button>
              <b-button title="Visualizar" class="btn btn-sm btn-secondary action"
                @click="navigate('/configurarConferencia/passo1/visualizar')">
                <i class="fa fa-search" style="color: black" />
              </b-button><span
                v-show="data.item.situacao === 'Rascunho' || data.item.situacao === 'Inscrição Aberta' || data.item.situacao === 'Em Execução'"></span>
              <b-button title="Alterar Situação" class="btn btn-sm btn-secondary action" @click="abrirAlteracaoSituacao"
                v-show="data.item.situacao === 'Rascunho' || data.item.situacao === 'Inscrição Aberta' || data.item.situacao === 'Em Execução'">
                <i class="fa fa-cog" style="color: black" />
              </b-button><span
                v-show="data.item.situacao === 'Inscrição Aberta' || data.item.situacao === 'Em Execução' || data.item.situacao === 'Finalizada'"></span>
              <b-button title="Pausar" class="btn btn-sm btn-secondary action" @click="pausarConferencia"
                v-show="data.item.situacao === 'Inscrição Aberta' || data.item.situacao === 'Em Execução' || data.item.situacao === 'Finalizada'">
                <i class="fa fa-pause" style="color: black" />
              </b-button><span v-show="data.item.situacao === 'Suspensa'"></span>
              <b-button title="Retomar" class="btn btn-sm btn-secondary action" @click="$bvModal.show('modalRetomada')"
                v-show="data.item.situacao === 'Suspensa'">
                <i class="fa fa-play" style="color: black" />
              </b-button>
              <b-button title="Habilitar Importação de Participantes em Lote" class="btn btn-sm btn-secondary action"
                @click="chamaModalImportacaoParticipante" v-show="!data.item.permite_importar_participantes">
                <i class='fa fa-circle' style='color: red'></i>
              </b-button>
              <b-button title="Desabilitar Importação de Participantes em Lote" class="btn btn-sm btn-secondary action"
                @click="chamaModalImportacaoParticipante" v-show="data.item.permite_importar_participantes">
                <i class='fa fa-circle' style='color: green'></i>
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-col>
    </b-row>
    <b-row>
      <b-col>&nbsp;</b-col>
    </b-row>
    <b-modal id="alterarSituacao" :title="pausar ? 'Pausar Conferência' : 'Alterar Situação da Conferência'"
      no-close-on-backdrop hide-footer centered hide-header-close no-close-on-esc>
      <b-form @submit.stop.prevent="alterarSituacao">
        <b-row class="mb-2">
          <b-col>
            <b-form-group label="Nome da Conferência:">
              <b-form-input v-model="conferencia.conferencia_nome" disabled />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <b-form-group label="Situação Atual:">
              <b-form-select :options="situacaoAtual" disabled
                :value="configurarConferencias.length > 0 ? configurarConferencias[0].situacao : null" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Situação Nova: *" v-show="!pausar">
              <b-form-select v-model="novaSituacao" :options="situacoes" :required="!pausar" @input="naTrocaSituacao" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-2" v-show="novaSituacao === 'Suspensa' || pausar">
          <b-col>
            <p style="color: red">Atenção!</p>
            <p v-show="!pausar">Ao <b>Suspender</b> a conferência, não será possível que os usuários vinculados a ela
              possam acessá-la. Para retomá-la, procure um administrador do sistema.</p>
            <p v-show="pausar">Ao <b>Pausar</b> a conferência, a mesma receberá situação <b>Suspensa</b> e não será
              possível que os usuários vinculados a ela possam acessá-la. Para retomá-la, procure um administrador do
              sistema.</p>
            <p>Digite abaixo a mensagem que será exibida na url da Conferência quando os usuários tentarem acessá-la:</p>
            <b-form-textarea v-model.trim="suspensao" no-resize rows="3"
              :required="novaSituacao === 'Suspensa' || pausar" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button @click="$bvModal.hide('alterarSituacao')">
              <i class="fa fa-times" />&nbsp;&nbsp;Cancelar
            </b-button>
          </b-col>
          <b-col>
            <b-row no-gutters align-h="end">
              <b-button type="submit" variant="primary">
                <i class="fa fa-floppy-o" />&nbsp;&nbsp;Salvar
              </b-button>
            </b-row>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal :title="'Importação de Participantes em Lote'" v-model="modalPermiteImportacao" :hide-footer="true">
        <b-row>
          <b-col>
            <b-form-group label="Habilitado:">
              <b-form-radio-group v-model="optionsImportar" :disabled="disable_buttons" :options="status"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="exibirFormulario">
          <b-col cols="8">
            <b-form-group label="Formulário:">
              <b-form-select :disabled="disable_buttons" v-model.trim="conferencia.formulario_id" class="mb-3">
                <option :value="null">Selecione...</option>
                <option v-for="item in formularios" :value="item.id" :key="item.id"> {{ item.titulo }}</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button :disabled="disable_buttons" @click="modalPermiteImportacao = false">
              <i class="fa fa-times" />&nbsp;&nbsp;Cancelar
            </b-button>
          </b-col>
          <b-col>
            <b-row no-gutters align-h="end">
              <b-button :disabled="disable_buttons" @click="alterarImportacaoParticipante" variant="primary">
                <i class="fa fa-floppy-o" />&nbsp;&nbsp;Salvar
              </b-button>
            </b-row>
          </b-col>
        </b-row>
    </b-modal>
    <b-modal id="modalRetomada" title="Retomar Conferência" no-close-on-backdrop centered hide-header-close
      no-close-on-esc hide-footer>
      <b-row class="mb-2">
        <b-col>Deseja retomar a Conferência com a situação anterior à pausa/suspensão?</b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row no-gutters align-h="end">
            <b-button @click="$bvModal.hide('modalRetomada')">Cancelar</b-button>&nbsp;&nbsp;&nbsp;
            <b-button @click="$bvModal.hide('modalRetomada'); abrirAlteracaoSituacao()"
              variant="danger">Não</b-button>&nbsp;&nbsp;&nbsp;
            <b-button @click="$bvModal.hide('modalRetomada'); retomar()" variant="primary">Sim</b-button>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modalAlertaRetomada" no-close-on-backdrop centered hide-header no-close-on-esc ok-only>
      Datas da conferência expiradas. É necessário atualizá-las para prosseguir com a conferência.
    </b-modal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import miniToastr from 'mini-toastr'
import moment from 'moment'

export default {
  data() {
    return {
      totalPorPagina: 10,
      paginaAtual: 1,
      configurarConferencias: [],
      campos: [
        { key: 'nome', label: 'Nome da Conferência - Sigla', sortable: false },
        { key: 'publica', label: 'Pública', sortable: false },
        { key: 'execucao_inicio', label: 'Início da Execução', sortable: false },
        { key: 'execucao_termino', label: 'Término da Execução', sortable: false },
        { key: 'situacao', label: 'Status', sortable: false },
        { key: 'id', label: 'Ações', sortable: false, tdClass: 'centro', thClass: 'centro' }
      ],
      status: [
        { value: true, text: 'Sim' },
        { value: false, text: 'Não' }
      ],
      exibirFormulario: false,
      disable_buttons: false,
      modalPermiteImportacao: false, 
      formularios: [],
      situacaoAtual: [],
      situacoes: [],
      optionsImportar: false,
      novaSituacao: null,
      suspensao: null,
      pausar: false
    }
  },
  mounted() {
    this.configurarConferencias.push(this.configurarConferencia)

    if (this.mensagemConferencia) {
      this.sucesso(this.mensagemConferencia)
      this.$store.commit('setMensagemConferencia', null)
    }
    this.carregarFormularios()
  },
  computed: {
    ...mapState({
      usuario: state => state.usuario.usuario,
      conferencia: state => state.conferencia.conferencia,
      configurarConferencia: state => state.conferencia.configurarConferencia,
      mensagemConferencia: state => state.conferencia.mensagem
    })
  },
  watch: {
    'optionsImportar': function (){
      if (this.optionsImportar) {
        this.exibirFormulario = true
      } else {
        this.conferencia.formulario_id = null
        this.exibirFormulario = false
      }    

      this.conferencia.permite_importar_participantes = this.optionsImportar
    },
  },
  methods: {
    navigate(route) {
      this.$router.push(route)
    },
    sucesso(mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Sucesso',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'info'
      })
    },
    erro(mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Erro',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'danger'
      })
    },
    alerta(mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Alerta',
        autoHideDelay: 30000,
        appendToast: true,
        variant: 'warning'
      })
    },
    editar() {
      let situacao = this.configurarConferencias[0].situacao

      if (situacao === 'Rascunho') {
        this.navigate('/configurarConferencia/passo1/editar')
      } else if (situacao === 'Inscrição Aberta' || situacao === 'Em Execução') {
        this.navigate('/configurarConferencia/passo2/editar')
      } else {
        this.navigate('/configurarConferencia/passo3/editar')
      }
    },
    relacionar() {
      this.navigate('/configurarConferencia/relacionar')
    },
    abrirAlteracaoSituacao() {
      let situacoes = ['Rascunho', 'Inscrição Aberta', 'Em Execução', 'Suspensa', 'Finalizada']

      this.pausar = false
      this.novaSituacao = null
      this.suspensao = null
      this.situacaoAtual = []
      this.situacoes = []

      for (let i = 0; i < situacoes.length; i++) {
        let opcao = { text: situacoes[i], value: situacoes[i] }

        if (this.configurarConferencias[0].situacao === situacoes[i]) {
          this.situacaoAtual.push(opcao)
        } else {
          this.situacoes.push(opcao)
        }
      }

      this.$bvModal.show('alterarSituacao')
    },
    pausarConferencia() {
      this.abrirAlteracaoSituacao()
      this.pausar = true
    },
    naTrocaSituacao() {
      if (this.novaSituacao === 'Suspensa') {
        this.suspensao = null
      }
    },
    chamaModalImportacaoParticipante() {
      this.optionsImportar = this.configurarConferencias[0].permite_importar_participantes
      this.conferencia.formulario_id = this.configurarConferencias[0].formulario_id

      this.modalPermiteImportacao = true
    },
    alterarImportacaoParticipante() {

      if(this.conferencia.permite_importar_participantes && !this.conferencia.formulario_id){
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Campo Formulário e obrigatório!', 'Alerta', 5000)
        return false
      }

      this.$bvModal.msgBoxConfirm(this.conferencia.permite_importar_participantes ? 'Tem certeza que deseja habilitar a importação de participantes em lote?' : 'Tem certeza que deseja desabilitar a importação de participantes em lote?', {
        noCloseOnBackdrop: true,
        centered: true,
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.disable_buttons = true
          Vue.http.put('api/configurarConferencia/alterarImportacaoParticipante', this.conferencia).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.configurarConferencias[0].permite_importar_participantes = this.conferencia.permite_importar_participantes
              this.configurarConferencias[0].formulario_id = this.conferencia.formulario_id
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.disable_buttons = false
            this.modalPermiteImportacao = false
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      })
    },
    alterarSituacao() {
      this.$bvModal.msgBoxConfirm(this.pausar ? 'Tem certeza que deseja pausar esta conferência? Sua situação será alterada para Suspensa e todos os usuários vinculados a ela perderam o acesso. ' : 'Tem certeza que deseja alterar a situação desta conferência?', {
        noCloseOnBackdrop: true,
        centered: true,
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.configurarConferencias[0].situacao = this.pausar ? 'Suspensa' : this.novaSituacao
          this.configurarConferencias[0].suspensa = this.suspensao

          let dados = {
            id: this.configurarConferencias[0].id,
            situacao: this.configurarConferencias[0].situacao,
            user_id: this.usuario.id,
            acao: this.pausar ? 'Pausar Execução de Conferência' : 'Alterar Situação de Conferência'
          }

          if (this.configurarConferencias[0].situacao === 'Suspensa') {
            dados['suspensa'] = this.suspensao
          }

          Vue.http.post('api/configurarConferencia/alterarSituacao', dados)
          this.configurarConferencia.situacao = this.configurarConferencias[0].situacao
          this.configurarConferencia.suspensa = this.suspensao
          this.$bvModal.hide('alterarSituacao')
          if (this.pausar || this.configurarConferencias[0].situacao === 'Suspensa') {
            this.$store.commit('setMensagemConferencia', this.pausar ? 'Conferência pausada com sucesso!' : 'Situação da conferência alterada com sucesso!')
            this.navigate('/')
          } else {
            this.sucesso('Situação da conferência alterada com sucesso!')
          }
        }
      })
    },
    retomar() {

      let inscricao_termino = moment(this.configurarConferencia.inscricao_termino).format("YYYYMMDD")
      let data_atua = moment().format("YYYYMMDD")

      if(data_atua > inscricao_termino){
        this.$bvModal.show('modalAlertaRetomada')
        return false
      }

      Vue.http.get('api/configurarConferencia/obterHistoricoConfiguracao/' + this.configurarConferencia.id).then(response => {
        if (response.body.success && response.body.data.length > 0) {
          let historico = response.body.data

          if (historico.length >= 2) {
            let dados = {
              id: historico[1].configurar_conferencia_id,
              situacao: historico[1].situacao,
              user_id: this.usuario.id,
              acao: 'Retomar Conferência'
            }

            Vue.http.post('api/configurarConferencia/alterarSituacao', dados)
            this.configurarConferencias[0].situacao = historico[1].situacao
            this.configurarConferencia.situacao = historico[1].situacao
            this.sucesso('Conferência retomada com sucesso!')
          }
        }
      })
    },
    carregarFormularios() {
      Vue.http.get('api/formulario/relacionados/' + true).then(response => {
        if (response.body.success) {
          this.formularios = response.body.data
        }
      })
    },
    formatarData(data) {
      return data.substr(8, 2) + '/' + data.substr(5, 2) + '/' + data.substr(0, 4)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/conferencia/Gerenciar.vue